import React from "react";
import { CheckSquare, Square } from "react-feather";
import modulosId from "../mocks/modulos";

export const alertUtil = (alert) => ({
  ...alert,

  statusHtml: () => {
    if (alert.status === "resuelto") {
      return <span className="text-success">Resuelto</span>;
    }
    if (alert.status === "vencido") {
      return <span className="text-danger">Vencido</span>;
    }
    return <span className="text-warning">Pendiente</span>;
  },

  liderOrResponsableOrObservador(currentUser) {
    if (currentUser.user.Pi.itemId === alert.responsableId || currentUser.user.Pi.itemId === alert.liderId || currentUser.user.Pi.itemId === alert.observadorId) {
      return true;
    }
    return false;
  },

  canSetCompleted(currentUser) {
    if (!alert.completeDate) {
      if (currentUser.haveAuditAccess(modulosId.CALENDAR)) {
        // el auditor del modulo no puede rechazar
        return false;
      }
      if (currentUser.haveAdminAccess(modulosId.CALENDAR)) {
        // el admin del modulo puede completar
        return true;
      }
      if (this.liderOrResponsableOrObservador(currentUser)) {
        // es el responsable y/o lider de esta tarea
        return true;
      }
    }
    return false;
  },

  canSetRejected(currentUser) {
    if (alert.completeDate) {
      if (currentUser.haveAuditAccess(modulosId.CALENDAR)) {
        // el auditor del modulo no puede rechazar
        return false;
      }
      if (currentUser.haveAdminAccess(modulosId.CALENDAR)) {
        // el admin del modulo puede rechazar
        return true;
      }
      if (this.liderOrResponsableOrObservador(currentUser)) {
        // el responsable y/o lider puede rechazarse su tarea
        return true;
      }
    }
    return false;
  },

  statusCheck(handleTogleCheck, currentUser) {
    if (this.canSetRejected(currentUser)) {
      return (
        <span className="action-box complete-btn" title="Completado">
          <CheckSquare color="red" onClick={() => handleTogleCheck(alert.id)} />
        </span>
      );
    }
    if (this.canSetCompleted(currentUser)) {
      return (
        <span className="action-box complete-btn" title="Incompleto">
          <Square onClick={() => handleTogleCheck(alert.id)} />
        </span>
      );
    }
    return <>&nbsp;</>;
  },
});
